import { createContext, useContext, type ReactNode } from "react";

/** The shell header rendered inside the browsing content pane. */
export const BrowserWorkspaceChromeContext = createContext<{ header: ReactNode; workspaceControls?: ReactNode } | null>(null);
export const useBrowserWorkspaceChrome = () => useContext(BrowserWorkspaceChromeContext);
